// ADDED
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";
import * as legacyApi from "../../components/Personnel/EmployeesListFld/EmployeesListApi";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

export const employeeTransactionService = {
  // Changed from GET to POST and now accepts filters
  getAll: async (filters = [], employeeId = null) => {
    // Wrap filters in the object expected by the DTO
    const payload = { Filters: filters };
    const res = await axios.post(`${domain}/api/EmployeeTransaction/preview`, payload, { headers });
    let data = res.data || [];

    if (employeeId) {
      data = data.filter(r => r.assignedEmployeePersonalInformationId === employeeId);
    }
    return data;
  },

  getEmployeeHistoryData: async (employeePersonalInformationId) => {
    const res = await axios.get(`${domain}/api/EmployeeTransaction/employee-history/${employeePersonalInformationId}`, { headers });
    let data = res.data || [];
    
    return data;
  },
  
  create: async (payload) => {
    return await axios.post(`${domain}/api/EmployeeTransaction`, payload, { headers });
  },

  update: async (id, payload) => {
    return await axios.put(`${domain}/api/EmployeeTransaction/${id}`, payload, { headers });
  },

  submitForBypassApproval: async (id, payload) => {
    return await axios.put(`${domain}/api/EmployeeTransaction/${id}/bypass-approval`, payload, { headers });
  },

  markAsForApproval: async (id) => {
    return await axios.put(`${domain}/api/EmployeeTransaction/${id}/mark-transaction-for-approval`, null, { headers });
  },

  markAsDeparted: async (id) => {
    return await axios.put(`${domain}/api/EmployeeTransaction/${id}/mark-transaction-as-departed`, null, { headers });
  },

  markAsArrived: async (id, payload) => {
    return await axios.put(`${domain}/api/EmployeeTransaction/${id}/mark-transaction-as-arrived`, payload, { headers });
  },

  // Abstracted wrapper for legacy dropdowns
  getMetadata: async () => {
    const [
      shifts,
      classifications,
      employments,
      payTypes,
      salaryTypes,
      dailySalaries,
      monthlySalaries,
      quotaSalaries,
      employeeTypes,
      employeeStatusMaintenance,
    ] = await Promise.all([
      legacyApi.fetchDataForShiftSchedule(),
      legacyApi.fetchDataForClassification(),
      legacyApi.fetchDataForEmployment(),
      legacyApi.fetchDataForPaytype(),
      legacyApi.fetchSalaryType(),
      legacyApi.fetchDataEmployeeDailySalary(),
      legacyApi.fetchDataEmployeeSalary(),
      legacyApi.fetchDataQuotaBasedSalary(),
      legacyApi.fetchDataForEmployeeType(),
      legacyApi.fetchAllEmployeeStatusMaintenanceData(),
    ]);

    return {
      options: {
        shiftSchedules: shifts.map(s => ({ value: s.id, label: s.shiftName })),
        classifications: classifications.map(c => ({ value: c.id, label: c.description })),
        employments: employments.map(e => ({ value: e.id, label: e.description })),
        payTypes: payTypes.map(e => ({ value: e.id, label: e.description })),
        salaryTypes: salaryTypes.map(s => ({ value: s, label: s })),
        employeeTypes: employeeTypes.map(e => ({ value: e.id, label: e.description })),
        employeeStatusMaintenance: employeeStatusMaintenance.map(e => ({ value: e.id, label: e.description })),
      },
      salaryData: {
        daily: dailySalaries,
        monthly: monthlySalaries,
        quotaBased: quotaSalaries,
      }
    };
  },

  // ── APPROVALS: Employee Transaction Requests ──────────────────────────────
  getRequestsForApprover: async (approverId, filters) => {
    const res = await axios.get(`${domain}/api/EmployeeTransaction/approval-list`, { headers });
    return res.data;
  },
  approveRequest: async (id, approverId) => {
    const res = await axios.put(`${domain}/api/EmployeeTransaction/${id}/approve`, { approverId }, { headers });
    return res.data;
  },
  disapproveRequest: async (id, approverId, approverRemarks) => {
    const res = await axios.put(`${domain}/api/EmployeeTransaction/${id}/disapprove`, { approverId, approverRemarks }, { headers });
    return res.data;
  },
};